import Model from '@/store/plugins/orm/Model'
import { Product } from './ModelRepository'

export class ProductIngredient extends Model {
    static get entity () {
        return 'product_ingredients'
    }

    static fields () {
        return {
            id: this.attr(null),
            product_id: this.attr(null),
            super_product_id: this.attr(null),
            quantity: this.attr('0.000', value => _.round(value, 3).toFixed(3)),

            product: this.belongsTo(Product, 'product_id'),
            super_product: this.belongsTo(Product, 'super_product_id'),
        }
    }

    getQuantity() {
        return parseFloat(this.quantity);
    }
}

export default ProductIngredient
